import { createStyles } from '@material-ui/core';
export var radioStyles = function (theme) {
    return createStyles({
        root: {
            color: theme.palette.text.secondary,
            '&:hover': {
                color: theme.palette.secondary.main,
                backgroundColor: 'transparent',
            },
        },
        checked: {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
        },
    });
};
